import { render, staticRenderFns } from "./unmatch.vue?vue&type=template&id=58858a6c&scoped=true"
import script from "./unmatch.vue?vue&type=script&lang=js"
export * from "./unmatch.vue?vue&type=script&lang=js"
import style0 from "./unmatch.vue?vue&type=style&index=0&id=58858a6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58858a6c",
  null
  
)

export default component.exports